import axios from 'axios';

const backendClient = () => {
  const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'custom-headers':
        'a9f8d7b6c5e4f3a2d1c0b9a8f7e6d5c4b3a2f1e0d9c8b7a6f5e4d3c2b1a0f9e8d7c6b5a4',
    },
  });

  api.interceptors.request.use(config => {
    try {
      const persistFretapp = localStorage.getItem('persist:fretapp');
      if (persistFretapp) {
        const distributorString = JSON.parse(persistFretapp)?.distributor;
        if (distributorString) {
          const distributor = JSON.parse(distributorString);
          const token = distributor?.token ?? null;

          if (token) {
            config.headers.Authorization = `Bearer ${token}`;
            // console.log('[Interceptor] ✅ Token aplicado:', token);
          } else {
            console.warn(
              '[Interceptor] ⚠️ Token ausente no objeto "distributor".',
            );
          }
        } else {
          console.warn('[Interceptor] ⚠️ Campo "distributor" não encontrado.');
        }
      } else {
        console.warn('[Interceptor] ⚠️ persist:fretapp não encontrado.');
      }
    } catch (error) {
      console.error('[Interceptor] ❌ Erro ao recuperar token:', error);
    }

    return config;
  });

  return api;
};

export const api = backendClient();
